import React from "react";
import BaseInput from "../../../toolkit/baseInput";
import IInput from "../iInput/IInput";
import ITextProps from "./IText.props";
import ITextState from "./IText.state";
import BasePasswordInput from "../../basePasswordInput";
import BaseNumericInput from "../../baseNumericInput";
import BaseAlphabeticInput from "../../baseAlphabeticInput";
import BaseAlphanumericInput from "../../baseAlphanumericInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export default class IText extends IInput<ITextProps, ITextState> {
  state = {
    value: "",
    isExpanded: false
  };

  componentDidMount(): void {
    if (this.props.init) {
      this.setState(
        {
          value: this.props.init
        },
        () => super.triggerInput()
      );
    } else {
      super.triggerInput();
    }
  }

  componentDidUpdate(prevProps): void {
    if (this.props.init != prevProps.init) {
      this.setState({
        value: this.props.init
      });
    }
  }

  onChange = evt => {
    const value = evt.target.value;
    this.props.setter(this.props.name, value);
    this.props.onChange && this.props.onChange(value);
    this.setState({ value });
  };

  toggleExpanded = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onExpandRow) {
      this.props.onExpandRow();
    }

    this.setState({ isExpanded: !this.state.isExpanded });
  };

  render() {
    if (this.props.hidden) {
      return null;
    }

    const input = this.renderInput();
    const isExpanded = this.props.rowExpanded || this.state.isExpanded;

    if (this.props.onTable) {
      if (this.props.cellCollapsed && !isExpanded) {
        return (
          <td className={this.props.classCol || ""}>
            {this.renderCollapsed()}
          </td>
        );
      }
      return <td className={this.props.classCol || ""}>{input}</td>;
    }

    return <div className={this.btsClassName()}>{input}</div>;
  }

  renderCollapsed = () => {
    const displayValue =
      this.state.value || (this.state.value as any) === 0
        ? this.state.value
        : "---";

    return (
      <div
        onClick={this.toggleExpanded}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent:
            this.props.disabled && this.props.type === "NUMERIC"
              ? "flex-end"
              : "space-between",
          padding: "6px 10px",
          backgroundColor: this.props.disabled ? "unset" : "#f5f5f5",
          borderRadius: "4px",
          cursor: this.props.disabled ? "default" : "pointer",
          minHeight: "32px",
          border: this.props.disabled ? "unset" : "1px solid #e0e0e0",
          transition: "all 0.2s ease",
          lineHeight: "19px"
        }}
        onMouseEnter={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#ebebeb";
          }
        }}
        onMouseLeave={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }
        }}
      >
        {this.props.type === "NUMERIC" ? (
          <>
            {!this.props.disabled && (
              <FontAwesomeIcon
                icon={faEdit}
                color="#999"
                style={{
                  marginBottom: "4px",
                  flexShrink: 0,
                  fontSize: "12px"
                }}
              />
            )}

            <div
              style={{
                color:
                  this.state.value || (this.state.value as any) === 0
                    ? "#333"
                    : "#999",
                fontSize: "14px"
              }}
            >
              {this.props.cellFormatter
                ? this.props.cellFormatter(displayValue)
                : displayValue}
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                color:
                  this.state.value || (this.state.value as any) === 0
                    ? "#333"
                    : "#999",
                fontSize: "14px"
              }}
            >
              {this.props.cellFormatter
                ? this.props.cellFormatter(displayValue)
                : displayValue}
            </div>
            {!this.props.disabled && (
              <FontAwesomeIcon
                icon={faEdit}
                color="#999"
                style={{
                  marginLeft: "8px",
                  marginBottom: "4px",
                  flexShrink: 0,
                  fontSize: "12px"
                }}
              />
            )}
          </>
        )}
      </div>
    );
  };

  renderInput = () => {
    let InputComponent = BaseInput;
    switch (this.props.type) {
      case "PASSWORD":
        InputComponent = BasePasswordInput;
        break;
      case "NUMERIC":
        InputComponent = BaseNumericInput;
        break;
      case "ALPHABETIC":
        InputComponent = BaseAlphabeticInput;
        break;
      case "ALPHANUMERIC":
        InputComponent = BaseAlphanumericInput;
    }

    return (
      <InputComponent
        label={this.props.onTable ? undefined : this.props.label}
        name={this.props.name}
        type="text"
        id={`${this.props.formKey || ""}-${this.props.name}`}
        size={"sm"}
        disabled={this.props.disabled}
        value={this.state.value}
        onChange={this.onChange}
        errors={
          this.props.dirty && this.props.message ? [this.props.message] : null
        }
        onBlur={this.props.onBlur}
        maxlength={this.props.maxlength || null}
        uppercase={this.props.uppercase || null}
        builder={this.props.onTable}
      />
    );
  };
}
